/**
 * Hides `.landing-cta-dock` (mobile landing CTAs) when the viewport reaches the bottom
 * so it does not float over the footer.
 */
export function landingCtaDockHideAtBottom() {
  const dock = document.querySelector(".landing-cta-dock");
  if (!dock) return;

  const hiddenClass = "landing-cta-dock--hidden-at-bottom";
  /** Pixels above the absolute bottom still counts as “at bottom”. */
  const thresholdPx = 56;

  let ticking = false;

  function update() {
    const docEl = document.documentElement;
    const scrollBottom =
      window.scrollY + window.innerHeight;
    const maxScrollBottom = docEl.scrollHeight;

    const atBottom = scrollBottom >= maxScrollBottom - thresholdPx;

    if (atBottom) {
      dock.classList.add(hiddenClass);
    } else {
      dock.classList.remove(hiddenClass);
    }
    ticking = false;
  }

  function onViewportChange() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener("scroll", onViewportChange, { passive: true });
  window.addEventListener("resize", onViewportChange, { passive: true });
  update();
}
